import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["variables"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { rebuildButtonAction, runTemplateOnInputs } from './utils';

/**
 * HOC that'll run template replacement on `MessageProps` fields of spotlight
 * messages and render the wrapped component.
 *
 * If any of the replacements fail with missing variables the component isn't
 * rendered and null is returned.
 *
 * The returned wrapped component accepts a `variables=` property which should
 * be a map of key to string value.
 *
 * This property isn't forwarded to the wrapped component
 *
 * @param TargetComponent<Props>
 * @returns {Component<Props & VariableProps>}
 */
export default function withVariables(TargetComponent) {
  // eslint-disable-next-line @repo/internal/react/no-class-components
  var WithVariables = /*#__PURE__*/function (_Component) {
    function WithVariables() {
      _classCallCheck(this, WithVariables);
      return _callSuper(this, WithVariables, arguments);
    }
    _inherits(WithVariables, _Component);
    return _createClass(WithVariables, [{
      key: "render",
      value: function render() {
        var props = runMessagePropsReplacement(this.props);
        if (!props) {
          return null;
        }
        return /*#__PURE__*/React.createElement(TargetComponent, props);
      }
    }]);
  }(Component);
  _defineProperty(WithVariables, "displayName", "".concat(TargetComponent.displayName || TargetComponent.name || '', "WithEPVariables"));
  return WithVariables;
}

/**
 * Runs replacement over spotlight message properties.
 * Returns null if replacement fails.
 */
function runMessagePropsReplacement(props) {
  var variables = props.variables,
    otherProps = _objectWithoutProperties(props, _excluded);
  var title = props.title,
    body = props.body,
    primaryText = props.primaryText,
    primaryAction = props.primaryAction,
    secondaryText = props.secondaryText,
    secondaryAction = props.secondaryAction;
  var inputs = {
    title: title,
    body: body,
    primaryText: primaryText,
    primaryActionUrl: primaryAction && primaryAction.data && primaryAction.data.url,
    secondaryText: secondaryText,
    secondaryActionUrl: secondaryAction && secondaryAction.data && secondaryAction.data.url
  };
  var replacedInputs = runTemplateOnInputs(variables || {}, inputs);
  if (!replacedInputs) {
    return null;
  }
  var outputProps = _objectSpread(_objectSpread({}, otherProps), {}, {
    title: replacedInputs.title,
    body: replacedInputs.body,
    primaryText: replacedInputs.primaryText,
    secondaryText: replacedInputs.secondaryText
  });
  if (primaryAction) {
    outputProps.primaryAction = rebuildButtonAction(replacedInputs.primaryActionUrl, primaryAction);
  }
  if (secondaryAction) {
    outputProps.secondaryAction = rebuildButtonAction(replacedInputs.secondaryActionUrl, secondaryAction);
  }
  return outputProps;
}